import React from 'react';
import { MapPin, TrendingUp } from 'lucide-react';
import { audienceInsights } from '../mock';

const AudienceInsights = () => {
  const { demographics, ageGroups, gender, topCities } = audienceInsights;

  return (
    <section className="py-20 bg-[#0A0F0D]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="text-[#22C55E]">72%</span> USA Audience
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Reach the exact demographic your brand needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Geographic Distribution */}
          <div className="bg-[#0F172A] border border-[#22C55E]/20 rounded-xl p-8 hover:border-[#22C55E]/50 transition-all duration-300">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
              <MapPin className="h-6 w-6 text-[#22C55E]" />
              Geographic Reach
            </h3>
            <div className="space-y-4">
              {Object.entries(demographics).map(([country, percentage]) => (
                <div key={country}>
                  <div className="flex justify-between mb-2">
                    <span className="text-[#94A3B8] capitalize">{country === 'usa' ? 'USA' : country}</span>
                    <span className="text-[#22C55E] font-semibold">{percentage}%</span>
                  </div>
                  <div className="h-2 bg-[#0A0F0D] rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-gradient-to-r from-[#22C55E] to-[#4ADE80] rounded-full progress-bar"
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Age Distribution */}
          <div className="bg-[#0F172A] border border-[#22C55E]/20 rounded-xl p-8 hover:border-[#22C55E]/50 transition-all duration-300">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
              <TrendingUp className="h-6 w-6 text-[#22C55E]" />
              Age Demographics
            </h3>
            <div className="space-y-4">
              {ageGroups.map((group) => (
                <div key={group.range}>
                  <div className="flex justify-between mb-2">
                    <span className="text-[#94A3B8]">{group.range} years</span>
                    <span className="text-[#22C55E] font-semibold">{group.percentage}%</span>
                  </div>
                  <div className="h-2 bg-[#0A0F0D] rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-gradient-to-r from-[#22C55E] to-[#4ADE80] rounded-full progress-bar"
                      style={{ width: `${group.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Top Cities */}
          <div className="bg-[#0F172A] border border-[#22C55E]/20 rounded-xl p-8 hover:border-[#22C55E]/50 transition-all duration-300 lg:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-6">Top Cities</h3>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
              {topCities.map((city, index) => (
                <div key={city.city} className="text-center">
                  <div className="relative w-20 h-20 mx-auto mb-3">
                    <svg className="transform -rotate-90 w-20 h-20">
                      <circle
                        cx="40"
                        cy="40"
                        r="32"
                        stroke="#0A0F0D"
                        strokeWidth="8"
                        fill="none"
                      />
                      <circle
                        cx="40"
                        cy="40"
                        r="32"
                        stroke="#22C55E"
                        strokeWidth="8"
                        fill="none"
                        strokeDasharray={`${city.percentage * 2} 200`}
                        className="progress-circle"
                        style={{ animationDelay: `${index * 100}ms` }}
                      />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-[#22C55E] font-bold text-lg">{city.percentage}%</span>
                    </div>
                  </div>
                  <p className="text-white font-semibold">{city.city}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceInsights;